import React, { lazy, Suspense } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';

// Lazy load components
const StockTransferList = lazy(() => import('../Pages/StockTransferList'));
const AddStockTransfer = lazy(() => import('../Pages/AddStockTransfer'));
const StockTransferView = lazy(() => import('../Pages/StockTransferView'));

// Import loading overlay
import LoadingOverlay from 'react-loading-overlay';
import EditStockTransfer from "../Pages/EditStockTransfer";
import VerifyStockTransfer from "../Pages/VerifyStockTransfer";
LoadingOverlay.propTypes = undefined;

function StockTransferRoute() {
    const history = useHistory();

    return (
        <Switch>
            <Route
                exact
                path="/:lng/stock/transfer"
                render={() => (
                    <Suspense fallback={<Loading />}>
                        <StockTransferList history={history} />
                    </Suspense>
                )}
            />
            <Route
                exact
                path="/:lng/stock/transfer/list"
                render={() => (
                    <Suspense fallback={<Loading />}>
                        <StockTransferList history={history} />
                    </Suspense>
                )}
            />
            <Route
                exact
                path="/:lng/stock/transfer/add"
                render={() => (
                    <Suspense fallback={<Loading />}>
                        <AddStockTransfer history={history} />
                    </Suspense>
                )}
            />
            <Route
                exact
                path="/:lng/stock/transfer/edit/:slack"
                render={() => (
                    <Suspense fallback={<Loading />}>
                        <EditStockTransfer history={history} />
                    </Suspense>
                )}
            />
            <Route
                exact
                path="/:lng/stock/transfer/view/:slack"
                render={() => (
                    <Suspense fallback={<Loading />}>
                        <StockTransferView history={history} />
                    </Suspense>
                )}
            />
            <Route
                exact
                path="/:lng/stock/transfer/verify/:slack"
                render={() => (
                    <Suspense fallback={<Loading />}>
                        <VerifyStockTransfer history={history} />
                    </Suspense>
                )}
            />
        </Switch>
    );
};

export default StockTransferRoute;

function Loading() {
    return (
        <>
            <div className="wrapper">
                <span>Loading</span>
            </div>
        </>
    );
}
